import {
    createSelector,
    createEntityAdapter
} from "@reduxjs/toolkit";
import { apiSlice } from "../../app/api/apiSlice"

const consumcatAdapter = createEntityAdapter({})

const initialState = consumcatAdapter.getInitialState()

export const consumcatApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getconsumcat: builder.query({
            query: () => ({
                url: '/consumcat',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                },
            }),
            transformResponse: responseData => {
                const loadedconsumcat = responseData.map(consumcat => {
                    // console.log(brandmaster)
                    consumcat.id = consumcat._id
                    // console.log(brandmaster)
                    return consumcat
                });
                return consumcatAdapter.setAll(initialState, loadedconsumcat)
            },
            providesTags: (result, error, arg) => {
                if (result?.ids) {
                    return [
                        { type: 'CONSUMCAT', id: 'LIST' },
                        ...result.ids.map(id => ({ type: 'CONSUMCAT', id }))
                    ]
                } else return [{ type: 'CONSUMCAT', id: 'LIST' }]
            }
        }),
        addNewconsumcat: builder.mutation({
            query: initialUserData => ({
                url: '/consumcat',
                method: 'POST',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: [
                { type: 'CONSUMCAT', id: "LIST" }
            ]
        }),
        updateconsumcat: builder.mutation({
            query: initialUserData => ({
                url: '/consumcat',
                method: 'PUT',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'CONSUMCAT', id: arg.id }
            ]
        }),        
        deletebconsumcat: builder.mutation({
            query: ({ id }) => ({
                url: `/consumcat`,
                method: 'DELETE',
                body: { id }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'CONSUMCAT', id: arg.id }
            ]
        }),
    }),
})

export const {
    useGetconsumcatQuery,
    useAddNewconsumcatMutation,
    useUpdateconsumcatMutation,
    useDeletebconsumcatMutation
} = consumcatApiSlice

// returns the query result object
export const selectconsumcatResult = consumcatApiSlice.endpoints.getconsumcat.select()

// creates memoized selector
const selectconsumcatData = createSelector(
    selectconsumcatResult,
    consumcatResult => consumcatResult.data // normalized state object with ids & entities
)

//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAllconsumcat,
    selectById: selectconsumcatById,
    selectIds: selectconsumcatIds
    // Pass in a selector that returns the users slice of state
} = consumcatAdapter.getSelectors(state => selectconsumcatData(state) ?? initialState)